import { animate, inView, scroll } from 'motion';
const initSmoothScroll = () => {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  
  if (!prefersReducedMotion) {
    document.documentElement.style.scrollBehavior = 'smooth';
  }
};

// Navigation snap animation with Motion
const initNavigationSnap = () => {
  const nav = document.querySelector('.landing-page-nav');
  if (!nav) return;

  scroll(
    ({ y }) => {
      const scrolled = y.current > 16;
      nav.classList.toggle('nav-snapped', scrolled);
    },
    { target: document.documentElement }
  );
};

// Overview interactions (removed scroll triggers)
const initOverviewInteractions = () => {
  const overviewItems = document.querySelectorAll('.overview__item');
  if (!overviewItems.length) return;

  // Items are now visible by default, no scroll animation needed
};

// Feature tab switcher with Motion
const initFeatureTabs = () => {
  const tabs = document.querySelectorAll('.features__tab');
  const showcases = document.querySelectorAll('.features__showcase-content');
  if (!tabs.length || !showcases.length) return;

  const activate = (feature) => {
    tabs.forEach((tab) => {
      const isActive = tab.dataset.feature === feature;
      tab.classList.toggle('is-active', isActive);
    });

    showcases.forEach((panel) => {
      const isActive = panel.dataset.showcase === feature;
      panel.classList.toggle('is-active', isActive);
    });
  };

  tabs.forEach((tab) => {
    tab.addEventListener('click', (event) => {
      event.preventDefault();
      activate(tab.dataset.feature);
    });
  });

  const defaultFeature = tabs[0]?.dataset.feature;
  if (defaultFeature) {
    activate(defaultFeature);
  }
};

// Initialize everything
const init = () => {
  initSmoothScroll();
  initNavigationSnap();
  initOverviewInteractions();
  initFeatureTabs();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
